(function () {
  'use strict';

  var bar = document.getElementById('sticky-add-to-cart');
  if (!bar) return;

  var btn = bar.querySelector('[data-add-to-cart-sticky]');
  var priceEl = bar.querySelector('[data-sticky-price]');
  var optSelects = bar.querySelectorAll('.sticky-add-to-cart__option');
  var qtyInput = bar.querySelector('.sticky-add-to-cart__qty-input');
  var nativeSelect = document.querySelector('select[name="id"]');
  var productData = null;
  var currentVariant = null;

  function fmt(c) {
    if (c == null) return '';
    return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function loadData() {
    if (productData) return true;
    var el = document.querySelector('.ProductJson-product');
    if (!el) return false;
    try {
      productData = JSON.parse(el.textContent);
      return true;
    } catch (e) { return false; }
  }

  function findVariant(optionValues) {
    if (!productData || !productData.variants) return null;
    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      var match = true;
      for (var j = 0; j < optionValues.length; j++) {
        if (v.options[j] !== optionValues[j]) {
          match = false;
          break;
        }
      }
      if (match) return v;
    }
    return null;
  }

  function getSelectedOptions() {
    var vals = [];
    for (var i = 0; i < optSelects.length; i++) {
      vals.push(optSelects[i].value);
    }
    return vals;
  }

  function findVariantFromStickySelects() {
    return findVariant(getSelectedOptions());
  }

  function update(v) {
    if (!v) return;
    currentVariant = v;
    priceEl.textContent = fmt(v.price);
    btn.disabled = !v.available;
    if (nativeSelect && v.id) {
      nativeSelect.value = v.id;
    }
  }

  function syncStickyFromNative() {
    if (!nativeSelect || !productData) return;
    var vid = parseInt(nativeSelect.value);
    if (!vid) return;
    var v = null;
    for (var i = 0; i < productData.variants.length; i++) {
      if (productData.variants[i].id == vid) {
        v = productData.variants[i];
        break;
      }
    }
    if (!v) return;
    currentVariant = v;
    priceEl.textContent = fmt(v.price);
    btn.disabled = !v.available;
    for (var j = 0; j < optSelects.length && j < v.options.length; j++) {
      optSelects[j].value = v.options[j];
    }
  }

  function onStickyOptionChange() {
    if (!productData) return;
    var v = findVariantFromStickySelects();
    if (v) {
      update(v);
    } else {
      currentVariant = null;
      priceEl.textContent = '';
      btn.disabled = true;
    }
  }

  function onSubmit(e) {
    e.preventDefault();
    if (btn.disabled) return;
    if (!nativeSelect) return;
    var v = findVariantFromStickySelects();
    if (v) nativeSelect.value = v.id;
    var qty = qtyInput ? (parseInt(qtyInput.value) || 1) : 1;
    var form = document.querySelector('form.ajax-product-form');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = nativeSelect.value;
    var xhr = new XMLHttpRequest();
    xhr.open('POST', form.action + '.js', true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.onload = function () {
      if (xhr.status === 200) {
        try {
          var data = JSON.parse(xhr.responseText);
          if (data.redirect_url) window.location.href = data.redirect_url;
        } catch (err) {}
      }
    };
    var params = form.querySelectorAll('input, select');
    var body = [];
    for (var i = 0; i < params.length; i++) {
      if (params[i].name && !params[i].disabled) {
        body.push(encodeURIComponent(params[i].name) + '=' + encodeURIComponent(params[i].value));
      }
    }
    body.push('quantity=' + qty);
    xhr.send(body.join('&'));
  }

  function onScroll() {
    var atc = document.querySelector('[data-add-to-cart][name="add"]');
    if (!atc) return;
    if (atc.getBoundingClientRect().bottom < 0) {
      bar.classList.add('is-visible');
      bar.setAttribute('aria-hidden', 'false');
    } else {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
    }
  }

  // Init data
  var ticks = 0;
  var t = setInterval(function () {
    ticks++;
    if (loadData()) {
      syncStickyFromNative();
      clearInterval(t);
    }
    if (ticks > 40) clearInterval(t);
  }, 250);

  // Sync sticky selects from Shopify's native select change
  if (nativeSelect) {
    nativeSelect.addEventListener('change', syncStickyFromNative);
  }

  // Listen for variantChange events from Shopify
  var section = document.querySelector('[data-section-type="product"]');
  if (section) {
    var orig = section.dispatchEvent.bind(section);
    section.dispatchEvent = function (evt) {
      var ret = orig(evt);
      if (evt.type && evt.type.indexOf('variantChange') === 0 && evt.variant) {
        update(evt.variant);
      }
      return ret;
    };
  }
  document.addEventListener('variantChange', function (e) {
    if (e.variant) update(e.variant);
  }, true);

  // Sticky option changes
  for (var i = 0; i < optSelects.length; i++) {
    optSelects[i].addEventListener('change', onStickyOptionChange);
  }
  onStickyOptionChange();

  // Sticky button
  if (btn) btn.addEventListener('click', onSubmit);

  // Scroll
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    bar.classList.remove('is-visible');
    setTimeout(onScroll, 200);
  });

  setTimeout(onScroll, 400);
  setTimeout(onScroll, 1200);
})();
